<template>
  <TsTabsCategorySelection
      :data-testid="props.dataTestid"
      :noShadow="props.noShadow"
      :append-class="props.appendClass"
      :align="props.align"
      :tabs="route_tabs"
      :active="route.path"
  />
</template>

<script setup lang="ts">


const TsTabsCategorySelection = defineAsyncComponent(
    () => import('~/components/molecules/TsTabsCategorySelection.vue')
);

const route = useRoute();

const localPath = useLocalePath();

type Tabs = {
  label: string;
  link: string;
  icon?: string;
}

type Props = {
  tabs?: Tabs[];
  align?: "left" | "center" | "right";
  dataTestid?: string;
  noShadow?: boolean;
  appendClass?: string;
};

const emit = defineEmits(['tabClick'])

const props = withDefaults(defineProps<Props>(), {
  tabs: () => ([])
});

const route_tabs = computed(() => {
  if(props.tabs.length > 0) return props.tabs.map((item) => ({
    ...item,
    id: localPath(item.link)
  }))

  return [];
})

const setActiveTag = (tab, index) => {
  emit("tabClick", tab, index);
};
</script>
